import React from "react";
import "../../css/components/Hero.css";

const renderLines = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};
function Hero({
  title = "",
  subtitle = "",
  backgroundImage = "",
  logo,
  titleAlign = "center", // "center" | "left"
  subtitleAlign = "center", // "center" | "left"
  lightOverlay = false,
  children,
  rightImage,

}) {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    > 
      <div
        className={`hero-overlay ${lightOverlay ? "light-overlay" : ""} ${rightImage ? "hero-row" : ""}`}
      >
        <div className="hero-content">
          {logo && <img src={logo} alt="Logo" className="hero-logo" />}
          <h3 style={{ textAlign: titleAlign }}>
            {renderLines(title)}
          </h3>
          <div className={`divider align-${titleAlign}`}></div>
          <div className="Title" style={{ textAlign: subtitleAlign }}>{renderLines(subtitle)}</div>
          {children}
        </div>
      </div>
    </section>
  );
}

export default Hero;
